import { NavLink } from 'react-router-dom'

const SCREENS = [
  { label: 'Produits', to: '/structured-products' },
  { label: 'Brouillons', to: '/structured-products/drafts' },
  { label: 'À traiter', to: '/structured-products/issues', badge: true },
]

const SpNav = ({ issuesCount }) => (
  <nav className='b_book_nav' aria-label='Produits structurés'>
    {SCREENS.map(({ label, to, badge }) => (
      <NavLink key={to} to={to} end className={({ isActive }) => `b_book_nav_tab ${isActive ? 'b_book_nav_tab_active' : ''}`}>
        {label}
        {badge && issuesCount > 0 && <span className='sp_nav_badge'>{issuesCount}</span>}
      </NavLink>
    ))}
  </nav>
)

export default SpNav
